import { agencyCore } from "./translations/agency-core";
import { agencyOnboarding } from "./translations/agency-onboarding";
import { agencyCandidates } from "./translations/agency-candidates";
import { agencyProfile } from "./translations/agency-profile";

/**
 * Hub file for agency translations.
 * Split into smaller files for better maintainability.
 */
export const agencyTranslations = {
  ...agencyCore,
  ...agencyOnboarding,
  ...agencyCandidates,
  ...agencyProfile,
};

// Re-export type if needed (currently inferred from the object)
export type AgencyTranslations = typeof agencyTranslations;
